import { ScaleLinear } from 'd3-scale';
import { NumberFormat } from '@instinet-analytics/core-lib';
import { deriveYAxisLabelProps } from '../axisLabel/deriveLabelProps';
import { YAxisLabelProps } from '../axisLabel/YAxisLabel';
import { estCostTooltip } from './help/plLegendTooltip';

export function deriveEstCostLabelProps(
    impactCost: number | undefined,
    numberFormat: NumberFormat,
    yScale: ScaleLinear<number, number>,
    height: number,
    width: number
): YAxisLabelProps | undefined {
    const key = 'estCost';
    const result = deriveYAxisLabelProps(
        [
            {
                key,
                type: 'Est Cost',
                tooltip: estCostTooltip,
                value: impactCost ? impactCost * -1 : undefined,
            },
        ],
        numberFormat.n2.bind(numberFormat),
        yScale,
        height,
        width
    );

    return result[key];
}
